var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    _vm._b(
      {
        attrs: {
          value: _vm.isOpen,
          fullscreen: _vm.isFullscreen,
          "content-class": "overflow-visible"
        },
        on: { input: _vm.handleInputChange }
      },
      "v-dialog",
      _vm.currentDialogProps || { width: "600px" },
      false
    ),
    [
      _c(
        _vm.currentComponent,
        _vm._b({ tag: "component" }, "component", _vm.currentProps, false)
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }